import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, HostBinding } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { Country } from 'app/modules/shared/models/country';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-entity-autocomplete-search',
  standalone: true,
  imports: [CommonModule, DropdownModule, FormsModule, AutoCompleteModule, ReactiveFormsModule, TranslateModule, InputTextModule, CheckboxModule, DividerModule, CommonModule],
  templateUrl: './entity-autocomplete-search.component.html',
  styleUrl: './entity-autocomplete-search.component.scss'
})
export class EntityAutocompleteSearchComponent implements OnInit {

  @Input() attributeValues;
  @Input() field: any;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  @Output() onSearchValueChange: EventEmitter<string> = new EventEmitter();
  formName: FormGroup;
  items: any[] = [];
  checked = [];
  selectedItem: any;
  filteredItems: any[] = [];

  @HostBinding('class') get componentClass() {
    return `entity-autocomplete-${this.field?.attributeCode || 'default'}`;
  }

  entityData = {
    viewCode: '',
    countryCode: '',
    forTenantCode: '',
    searchText: '',
    actionStatus: '',
    deleted: '',
    eventCode: '',
    filters: [],
    advanceFilters: []
  };
  placeholder: any;
  country: Country;

  constructor(
    private entityService: EntityService,
    private cs: CommonBindingDataService,
    private configService: ConfigService,
    private formGroupDirective: FormGroupDirective
  ) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.getInitialData();
    if (this.moduleName === 'change_review_grid') {
      this.placeholder = this.cs.getLabel('lbl_placeholder_review')
    } else {
      this.placeholder = this.cs.getLabel('lbl_search')
    }
  }


  getInitialData() {
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.entityData.countryCode = this.country[0].countryCode;
    this.entityData.viewCode = 'AUTOCOMPLETE_VIEW'

    this.fetchFromAPI(this.entityData.viewCode, '');
  }

  filterItems(event: AutoCompleteCompleteEvent) {
    const query = event.query;
    this.entityData.searchText = query;
    this.fetchFromAPI(this.entityData.viewCode, query);
  }

  onSelectItem(event) {
    AppSettings.PROTOCOL_ID = event.value.id;
    this.formName.controls[this.field.attributeCode].setValue(event.value.id);
    this.formName.controls[this.field.attributeCode].updateValueAndValidity();
  }

  fetchFromAPI(viewCode: string, search: string) {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    const requestBody = {
      viewCode,
      countryCode: this.country[0].countryCode,
      forTenantCode: this.configService.getForTenantCode(),
      searchText: search,
      actionStatus: "",
      deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
      filters: [],
      advanceFilters: []
    }


    this.entityService.autoComplete(this.field.fieldName, requestBody).subscribe(res => {
      this.items = this.cs.getTableData(res) || [];
      this.filteredItems = this.items.map(item => ({
        id: item.id,
        name: item.protocol_name
      })).sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  onClear() {
    this.selectedItem = null;
    this.formName.controls[this.field.attributeCode].setValue(null);
    this.formName.controls[this.field.attributeCode].updateValueAndValidity();
    this.entityData.searchText = '';
    this.fetchFromAPI(this.entityData.viewCode, '');
  }

}
